import {
  BookMakers,
  EventData,
  FancyMarkets,
  MatchOdds,
} from "../../models/EventData";
import { EventmarketsMap } from "../../models/sportsBookState";

export const getSportEvents = (events: EventData[]) => {
  return events;
};

export const getInPlayEvents = (eventsMap: { [key: string]: EventData[] }) => {
  return eventsMap;
};

export const getAllmarketsData = (marketsMap: EventmarketsMap) => {
  let markets: MatchOdds[] = [];
  if (marketsMap !== undefined && marketsMap !== null && Object.values(marketsMap).length > 0) {
    markets = Object.values(marketsMap);
  }
  return markets;
};

export const getAllMatchOddsData = (eventInfo: EventData): MatchOdds[] => {
  let markets: MatchOdds[];
  if (eventInfo && eventInfo.markets && eventInfo.markets.matchOdds) {
    if (eventInfo.markets.matchOdds.length > 1) {
      markets = [...eventInfo.markets.matchOdds];
    } else {
      markets = eventInfo.markets.matchOdds;
    }
  }

  let data = markets.filter((item) => item.marketType !== "LINE_ODDS");

  data?.sort((a, b) => {
    const aDesc =
      a.marketName === "Match Odds" ? "aaa" : a.marketName.toLowerCase();
    const bDesc =
      b.marketName === "Match Odds" ? "aaa" : b.marketName.toLowerCase();
    if (aDesc > bDesc) return 1;
    else if (aDesc < bDesc) return -1;
    return 0;
  });
  return data;
};

export const getEventInfo = (eventInfo: EventData) => {
  return eventInfo;
};

export const getFancyMarkets = (eventInfo: EventData): any[] => {
  let fancyMarkets: FancyMarkets[] = [];

  if (eventInfo && eventInfo.markets && eventInfo.markets.fancyMarkets) {
    // return eventInfo.markets.matchOdds;
    if (Object.values(eventInfo.markets.fancyMarkets).length > 1) {
      fancyMarkets = eventInfo.markets.fancyMarkets;
    }

    fancyMarkets = eventInfo.markets.fancyMarkets;
  }

  return fancyMarkets.sort((a, b) => {
    const aDesc = a.marketName;
    const bDesc = b.marketName;
    if (aDesc > bDesc) return 1;
    else if (aDesc < bDesc) return -1;
    return 0;
  });
};

export const getBookMakerMarkets = (eventInfo: EventData): BookMakers[] => {
  let bmMarkets: BookMakers[];

  if (eventInfo && eventInfo.markets.bookmakers) {
    // return eventInfo.markets.matchOdds;
    if (eventInfo.markets.bookmakers.length > 1) {
      let bMarkets = eventInfo.markets.bookmakers.filter(
        (bm) =>
          !(
            bm.marketName.toLowerCase() === "toss" &&
            bm.status.toLowerCase() === "suspended"
          )
      );
      bmMarkets = [...bMarkets];
    } else {
      bmMarkets = eventInfo.markets.bookmakers.filter(
        (bm) =>
          !(
            bm.marketName.toLowerCase() === "toss" &&
            bm.status.toLowerCase() === "suspended"
          )
      );
    }
  }
  return bmMarkets;
};
